import { Injectable, OnDestroy } from "@angular/core";
import * as mapboxgl from "mapbox-gl";
import { environment } from "../../../../environments/environment";
import { MapHelperService } from "../../../../services/map-helper.service";
import { LocationDTO } from "../../locations-map/models/LocationDTO";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
@Injectable({
  providedIn: "root",
})

export class MapService implements OnDestroy{
 
  public PresentationMode: boolean = false;
  public APIRoutingMode: boolean = false;
  mapbox = mapboxgl as typeof mapboxgl;
  Map: mapboxgl.Map;
  // Coordenadas de la localización donde queremos centrar el mapa
  Style: string = "mapbox://styles/mapbox/traffic-day-v2";
  //  Style: string = "mapbox://styles/danyelgtz/cl33z6spb001d16pjou3pqtf5";
  Lat: number = 0;
  Lng: number= 0;
  Zoom: number= 0;


  $PinSelected: LocationDTO;
  $IdPinSelected: string;
  Data: any;

  public streetViewUrl: SafeResourceUrl;
  public isStreetViewUrlReady: boolean = false;
  
  
  public Empty_GeoJson: any = {
    type: "FeatureCollection",
    features: [],
  };
  // Pitch: number;
  constructor(
    private MapHelper: MapHelperService,
    private sanitizer: DomSanitizer
  ) {
    this.mapbox.accessToken = environment.mapBoxToken;
    this.Zoom = 0;
    this.Lat = 0;
    this.Lng = 0;
    console.log('CONSTRUCTING THE service')

  }

    ngOnDestroy() {   
      console.log('KILL Destroy the xxx service')
    }

  ResetCamera() {
    this.Lat = 21.6854008;
    this.Lng = -104.2948259;
    this.FocusePinOut(this.Lat,this.Lng);
  }

  public CreateMapUnique(lat, lng, zoom, data) : any {
    this.Lat = lat;
    this.Lng = lng;
    this.Zoom = zoom;
    this.Data = data;
    
    console.log("CREATING UNIQUE MAP");
    this.MapHelper.CreateMapUnique("map",this.Style,this.Zoom,this.Lng,this.Lat,false,false,false);
  }


  public LoadMapLocations() : any {
    console.log("building LocationsMap");
    this.MapHelper.onLoadMapLocations();

  }

  public LoadRouteMap() {
    console.log("building RouteMap");
    this.MapHelper.onLoadMapRoutes();
    
  }

  public LoadMapGeofences() {
    console.log("building GeofencesMap");
    this.MapHelper.onLoadMapGeofences();
  }

  private initializeMapRoutes() {
    this.showHideLayer("satellite-layer");
    this.showHideLayer("satellite-layer");
    this.showHideLayer("routeResume-lineOpacityMin-layer");
  }

 public UpdateLayerGeoJson(id: string, data: any){
   this.MapHelper.UpdateLayerGeoJson(id,data);
 }
 
  public SetCenter(startLocation: any) {
    var array = startLocation.split(",");
    console.log(array);
    if (array != null) {
      this.FocusePin(array[1], array[0]);
    }
  }

  
  public SetBaseMapSatellite() {
    this.showHideLayer("satellite-layer");
  }

  private showHideLayer(layerName) {
    this.MapHelper.ShowHideLayer(layerName)
  }

  private drawLocations(data: any) {
    console.log("DrawLocations");
    console.log(data);
    // const geojsonSource = this.map.getSource(
    //   "customMarker"
    // ) as mapboxgl.GeoJSONSource;
    // console.log(geojsonSource);
    // geojsonSource.setData(data);

    // locations.forEach((element) => {
    //   //Draw Markers
    //   if(!element.color)
    //     {
    //       element.color = "yellow"
    //     }

    //   var marker = new mapboxgl.Marker({ color: element.color })
    //     .setLngLat([element.cordsX, element.cordsY])
    //     .setPopup(
    //        new mapboxgl.Popup({ offset: 0, className: "my-class" })
    //    .setLngLat([parseFloat(element.cordsX), parseFloat(element.cordsY)])
    //    .setHTML(getPinText(element))
    //    .setMaxWidth("300px")
    //    )
    //    .addTo(this.map);

    //   //Add event OnClick
    //   marker.getElement().addEventListener("click", (e) => {
    //    this.onClickPin(element);
    //    console.log(element);
    //   });
    // });
  }

  private getPinText(element: any): string {
    var textHtml = "<h1>Location " + element.identifier + "</h1>" + "<hr><br>";
    element.data.forEach((dato) => {
      textHtml = textHtml.concat(
        "<div>" +
          '<div class="row-item col-md-6 col-sm-6">' +
          "<label><strong>" +
          dato["key"] +
          "</strong></label>" +
          "</div>" +
          '<div class="row-item col-md-6 col-sm-6">' +
          "<label>" +
          dato["value"] +
          "</label>" +
          "</div>" +
          "</div>"
      );
    });
    return textHtml;
  }

  private loadLocationsSources() {
    this.MapHelper.AddSourceGeoJson("pointsSource",this.Data);
    // this.MapHelper.AddSourceGeoJson("gasolineras",this.Empty_GeoJson);
  }


  private onClickPin(element: LocationDTO) {
    this.FocusePin(element.cordsX, element.cordsY);
    this.$PinSelected = element;
  }

  public FocusePin(cordsX, cordsY) {
    this.MapHelper.FlyToCamera(cordsX, cordsY,"20");
  }
  public FocusePinOut(cordsX, cordsY) {
    this.MapHelper.FlyToCamera(cordsX, cordsY,"4");
  }

  public loadStreetView(coordX, coordY) {
    const url = 'http://maps.google.com/maps?q=&layer=c&cbll=' + coordY+','+coordX+'&cbp=12,0,0,0,0';
    window.open(url, '_blank');
    
    // pra i frame de streetview
    // const url = 'https://www.google.com/maps/embed?pb=!4v1618458822483!6m8!1m7!1s!2m2!1d'+coordY+'!2d'+coordX+'!3f100!4f0!5f0.7820865974627469';
    // this.streetViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    // this.isStreetViewUrlReady = true;
    // document.getElementById('streetView').style.zIndex = '6';
    
    // // Verificar si el botón ya existe para evitar duplicados
    // if (!document.getElementById('closeViewerBtn')) {
    //   const closeButton = document.createElement('button');
    //   closeButton.id = 'closeViewerBtn';
    //   closeButton.innerText = 'X';
    //   closeButton.style.position = 'absolute';
    //   closeButton.style.top = '10px';
    //   closeButton.style.right = '10px';
    //   closeButton.style.zIndex = '1000';
    //   closeButton.style.padding = '5px 10px';
    //   closeButton.style.backgroundColor = '#f00';
    //   closeButton.style.color = '#fff';
    //   closeButton.style.border = 'none';
    //   closeButton.style.cursor = 'pointer';

    //   document.getElementById('streetView').appendChild(closeButton);

    //   // evento para hover del botón
    //   closeButton.addEventListener('mouseover', () => {
    //     closeButton.style.backgroundColor = 'rgb(193 0 0)';
    //   });
    //   closeButton.addEventListener('mouseleave', () => {
    //     closeButton.style.backgroundColor = '#f00';
    //   });

    //   // evento para cerrar el Viewer
    //   closeButton.addEventListener('click', () => {
    //     document.getElementById('streetView').style.zIndex = '-1';
    //     closeButton.remove();
    //     this.isStreetViewUrlReady = false;
    //   });
    // }
  }
}
